/* Shared Build Your Set calibration and glyph rendering for bundle popups. */
(function () {
  'use strict';
  window.BundleMonogramPreview = function (container, rec, draft, glyphSample) {
    var cfg = { monogram: { glyphSample: glyphSample } };
    var GRID_IMAGE_WIDTH = 900;
    function fontName() { var f = window.monogram_font_faces; return ((f && f[0] && f[0].title) || 'Serif').toLowerCase(); }
    function sizeName() { var s = window.monogram_font_sizes; return ((s && s[0] && s[0].title) || '36pt').toLowerCase(); }
    function foilValue(f) { return f.title.toLowerCase(); }
    function foilLabel(f) { return f.title; }
    function upscale(url) { return url.replace(/([?&])width=\d+/, '$1width=900'); }
  var monogramPositions = {
  "39341877231719": {
    "source": "Duo_Vanity_Case_Black_1.png?v=1785246212",
    "x": 260,
    "y": 414
  },
  "51644007776628": {
    "source": "DuoVanityCase_Espresso.png?v=1785245716",
    "x": 257,
    "y": 414
  },
  "53501725737332": {
    "source": "DuoVanityCase_Pebble_a656e916-b851-4479-aab5-fb4a260d56ab.png?v=1785245715",
    "x": 258,
    "y": 410
  },
  "40388523360359": {
    "source": "DuoVanityCase_GingerBrown.png?v=1785245716",
    "x": 259,
    "y": 415
  },
  "40334955184231": {
    "source": "DuoVanityCase_GingerBrown_2.png?v=1785245715",
    "x": 262,
    "y": 410
  },
  "40334987755623": {
    "source": "Duo_Vanity_Case_Burgundy_Lizard_2_b6eff9aa-f18b-4d9a-a073-f394169fc670.png?v=1784384376",
    "x": 257,
    "y": 412
  },
  "40334984872039": {
    "source": "DuoVanityCase_Blush.png?v=1785245716",
    "x": 259,
    "y": 417
  },
  "40334961410151": {
    "source": "DuoVanityCase_Burgundy_1a4ff177-0855-4d9b-8ab3-29626b3430a4.png?v=1785245715",
    "x": 262,
    "y": 411
  },
  "52101413372276": {
    "source": "DuoVanityCase_RobinBlue.png?v=1785245715",
    "x": 257,
    "y": 412
  },
  "53501915529588": {
    "source": "DuoVanityCase_Navy.png?v=1785245715",
    "x": 258,
    "y": 414
  },
  "53869063274868": {
    "source": "DuoVanityCase_Crush.png?v=1785245715",
    "x": 260,
    "y": 414
  },
  "54413792280948": {
    "source": "DuoVanityCase_NoirCroc_7be5679d-156f-443b-b291-3466a77048fe.png?v=1785245715",
    "x": 260,
    "y": 415
  },
  "55220928250228": {
    "source": "DuoVanityCase_Forest_0515f0a9-6902-4e46-a00d-d7850a15b2f2.png?v=1787398163",
    "x": 256,
    "y": 412
  },
  "56129409155444": {
    "source": "Duo_Vanity_Case__Lavender_Pink.png?v=1789724173",
    "x": 260,
    "y": 409
  },
  "56229244273012": {
    "source": "Duo_Vanity_Case__Grey.png?v=1790862849",
    "x": 259,
    "y": 412
  },
  "56229246009716": {
    "source": "Duo_Vanity_Case__Cobalt_af4da022-a36b-4f48-9887-9dec2b443167.png?v=1790862926",
    "x": 260,
    "y": 414
  },
  "39341877592167": {
    "source": "Vanity_Case__Black_7001bf58-2577-4d08-b787-549a340312af.png?v=1785245710",
    "x": 260,
    "y": 418
  },
  "51644012626292": {
    "source": "Vanity_Case__Espresso_b87f0742-8830-4113-b59a-c95316dedd3c.png?v=1785245710",
    "x": 262,
    "y": 415
  },
  "53501834592628": {
    "source": "Vanity_Case__Pebble_1dc4002a-1168-435c-ae55-e743db36cfec.png?v=1785245710",
    "x": 259,
    "y": 414
  },
  "40388533026919": {
    "source": "Vanity_Case__Ginger_Brown_8fb8c1a6-49be-4ac3-ac99-49d7e1f5a53d.png?v=1785245710",
    "x": 262,
    "y": 414
  },
  "40336339894375": {
    "source": "Vanity_Case__Beige.png?v=1785245710",
    "x": 260,
    "y": 412
  },
  "40336365617255": {
    "source": "Vanity_Case__Off_White_fb2d5777-6231-4716-ae15-548afb75e5da.png?v=1785245710",
    "x": 263,
    "y": 416
  },
  "40336369582183": {
    "source": "Vanity_Case__Grey_4b8a74c6-e730-41aa-b0ac-d58a74386de9.png?v=1785245710",
    "x": 260,
    "y": 412
  },
  "40336394420327": {
    "source": "Duo_Vanity_Case_Burgundy_Lizard_3.png?v=1784384955",
    "x": 259,
    "y": 413
  },
  "40336383705191": {
    "source": "Vanity_Case__Blush.png?v=1785245710",
    "x": 260,
    "y": 417
  },
  "40336347431015": {
    "source": "Vanity_Case__Burgundy_f1528dfb-e35b-4a6f-b3b1-448be9aa0d71.png?v=1785245710",
    "x": 262,
    "y": 411
  },
  "52101413994868": {
    "source": "Vanity_Case__Robin_Blue.png?v=1785245710",
    "x": 257,
    "y": 413
  },
  "53501932994932": {
    "source": "Vanity_Case__Navy_23df1b4f-a525-43dc-9c26-93daf178ce62.png?v=1785245710",
    "x": 260,
    "y": 414
  },
  "53869069762932": {
    "source": "Vanity_Case__Crush_6176bbf2-542b-4365-9aa9-511d057f1a9b.png?v=1785245710",
    "x": 262,
    "y": 414
  },
  "54413800964468": {
    "source": "Vanity_Case__Noir_Croc_8f5d3cca-9346-48f7-baf1-4b4dfbeb539c.png?v=1785245709",
    "x": 259,
    "y": 417
  },
  "55220952629620": {
    "source": "VanityCase_Forest.png?v=1787399655",
    "x": 259,
    "y": 412
  },
  "55221036319092": {
    "source": "Vanity_Case__Cobalt.png?v=1787399912",
    "x": 258,
    "y": 413
  },
  "40160804962407": {
    "source": "Mini_Vanity_Case__Black_0a9a0a5d-5252-4f57-8da8-57da418c0f81.png?v=1785245960",
    "x": 257,
    "y": 414
  },
  "51644017115508": {
    "source": "Mini_Vanity_Case__Espresso_e8559919-8e14-4c9e-94a1-f16cd91fc36f.png?v=1785245960",
    "x": 251,
    "y": 410
  },
  "53501876568436": {
    "source": "Mini_Vanity_Case__Pebble_b53ae42a-4ede-4e90-8578-64f809baaad3.png?v=1785245960",
    "x": 257,
    "y": 412
  },
  "40388540989543": {
    "source": "Mini_Vanity_Case__Ginger_Brown_65cb19b4-f8d6-4ced-a1ab-6e17ae3db02c.png?v=1785245960",
    "x": 256,
    "y": 408
  },
  "40336433348711": {
    "source": "Mini_Vanity_Case__Beige.png?v=1785245960",
    "x": 264,
    "y": 415
  },
  "40336472866919": {
    "source": "Mini_Vanity_Case__Off_White_6cbdcf6c-ca63-4dcf-a487-1d32f6476abe.png?v=1785245959",
    "x": 260,
    "y": 412
  },
  "40336457039975": {
    "source": "MiniVanityCase-Grey_c13b5329-bcbc-4018-8542-014280080037.png?v=1761681252",
    "x": 259,
    "y": 411,
    "image": "//etoile.com/cdn/shop/files/Mini_Vanity_Case__Grey_cacd537b-8dc5-4bb5-bacd-b0bb38d50c83.png?v=1785245960&width=900"
  },
  "40336467820647": {
    "source": "Mini_Vanity_Case_Lilac_NEW.png?v=1784385090",
    "x": 264,
    "y": 412
  },
  "40336462643303": {
    "source": "Mini_Vanity_Case__Blush.png?v=1785245959",
    "x": 259,
    "y": 412
  },
  "40336441770087": {
    "source": "Mini_Vanity_Case__Burgundy_e13110a1-0db9-4196-bb04-fadfa0bbf149.png?v=1785245960",
    "x": 255,
    "y": 412
  },
  "52101414027636": {
    "source": "Mini_Vanity_Case__Robin_Blue.png?v=1785245960",
    "x": 258,
    "y": 412
  },
  "53501951377780": {
    "source": "Mini_Vanity_Case__Navy_70815339-a244-40ec-9cf7-11d2b192fe5c.png?v=1785245960",
    "x": 258,
    "y": 413
  },
  "53869026574708": {
    "source": "Mini_Vanity_Case__Crush_375b39ec-c545-4c62-8891-9a95080e6899.png?v=1785245960",
    "x": 257,
    "y": 411
  },
  "54413803815284": {
    "source": "Mini_Vanity_Case__Noir_Croc_65531130-6715-4aca-b05b-a89a9c8e83b6.png?v=1785245960",
    "x": 260,
    "y": 413
  },
  "55221071937908": {
    "source": "MiniVanityCase_Forest.png?v=1787401547",
    "x": 258,
    "y": 411
  },
  "51631282848116": {
    "source": "Oval_Toiletry_Case__Black_5d2c4247-7df5-4061-b653-3920f34265b9.png?v=1785246305",
    "x": 260,
    "y": 423
  },
  "51732673528180": {
    "source": "Oval_Toiletry_Case__Espresso_a23d42b4-dc48-47fb-91a7-5ba804c378e9.png?v=1785246305",
    "x": 264,
    "y": 420
  },
  "53501979263348": {
    "source": "Oval_Toiletry_Case__Pebble_79aa3fb4-8383-4d5d-ab55-2ee7502294e1.png?v=1785246305",
    "x": 260,
    "y": 423
  },
  "51624828043636": {
    "source": "Oval_Toiletry_Case__Ginger_Brown_5fff7fd6-47b5-4f8f-a98a-93f8cfb47583.png?v=1785246305",
    "x": 258,
    "y": 427
  },
  "52104622047604": {
    "source": "Oval_Toiletry_Case__Lavender_Pink_702bf0d8-f07f-4e61-91f0-91bb982a7686.png?v=1785246305",
    "x": 258,
    "y": 422
  },
  "52104622473588": {
    "source": "Oval_Toiletry_Case__Burgundy_0614af1b-0de6-4e84-bb66-68e2bf5c6cd4.png?v=1785246305",
    "x": 258,
    "y": 423
  },
  "52101414060404": {
    "source": "Oval_Toiletry_Case__Robin_Blue.png?v=1785246433",
    "x": 257,
    "y": 412
  },
  "53501943972212": {
    "source": "Oval_Toiletry_Case__Navy_cbaa86c7-0d2f-495e-8e84-ff2d2ba7227c.png?v=1785246305",
    "x": 255,
    "y": 424
  },
  "53868911853940": {
    "source": "Oval_Toiletry_Case__Crush_eaba7fe6-fdf5-4f46-aab8-a89e912a4c67.png?v=1785246305",
    "x": 256,
    "y": 428
  },
  "54413811941748": {
    "source": "Oval_Toiletry_Case__Noir_Croc_240efb5d-5f61-4a82-bb10-8165055ff984.png?v=1785246305",
    "x": 256,
    "y": 423
  },
  "39341878116455": {
    "source": "JetSetterTravelCaseBlack.png?v=1786662901",
    "x": 254,
    "y": 363
  },
  "40334884143207": {
    "source": "JetSetterTravelCase_Beige.png?v=1786361488",
    "x": 260,
    "y": 375
  },
  "40334885978215": {
    "source": "JetSetterTravelCase-OffWhite_2.png?v=1786371336",
    "x": 254,
    "y": 359
  },
  "40334884438119": {
    "source": "JetSetterTravelCase-Grey.png?v=1786371336",
    "x": 264,
    "y": 374
  },
  "40334884307047": {
    "source": "JetSetterTravelCase_Burgundy.png?v=1786371337",
    "x": 263,
    "y": 361
  },
  "40334884339815": {
    "source": "JetSetterTravelCase-Cobalt.png?v=1786371336",
    "x": 250,
    "y": 363
  },
  "40334884372583": {
    "source": "Jet_Setter_Travel_Case__Forest_0467b9cc-9eb4-4ea7-856b-fc486bfa22c3.png?v=1789547651",
    "x": 265,
    "y": 363
  },
  "40334885912679": {
    "source": "JetSetterTravelCase_LavenderPink.png?v=1786371336",
    "x": 257,
    "y": 366
  },
  "40334885945447": {
    "source": "JetSetterTravelCase_Lilac.png?v=1786371336",
    "x": 269,
    "y": 366
  },
  "32945620975719": {
    "source": "Clear_Makeup_Travel_Case__Black_b6ab2701-7437-4875-be5f-bad6a649dafe.png?v=1786733874",
    "x": 257,
    "y": 275
  },
  "40334851702887": {
    "source": "Clear_Makeup_Travel_Case__Beige.png?v=1785247182",
    "x": 258,
    "y": 284
  },
  "40334853898343": {
    "source": "Clear_Makeup_Travel_Case__Burgundy_b470e840-f724-4597-ae8d-32222b7f2393.png?v=1785247183",
    "x": 258,
    "y": 277
  },
  "40334853931111": {
    "source": "Clear_Makeup_Travel_Case__Cobalt.png?v=1785247486",
    "x": 257,
    "y": 280
  },
  "40334853963879": {
    "source": "Clear_Makeup_Travel_Case__Forest.png?v=1786366786",
    "x": 256,
    "y": 277
  },
  "40334853996647": {
    "source": "Clear_Makeup_Travel_Case__Grey_e1d51fa1-9834-42da-8fba-873d18b3bde6.png?v=1785247182",
    "x": 256,
    "y": 278
  },
  "40334854062183": {
    "source": "Clear_Makeup_Travel_Case__Lavender_Pink_Old_6718aee1-cb3f-44e9-a6cf-82507114bb46.png?v=1785247182",
    "x": 258,
    "y": 278
  },
  "40334854160487": {
    "source": "Clear_Makeup_Travel_Case__Lilac.png?v=1785247486",
    "x": 253,
    "y": 286
  },
  "54425234571636": {
    "source": "Clear_Makeup_Travel_Case__Pebble_c6c2f4f5-2365-4d68-8d7a-b7b985664331.png?v=1785247486",
    "x": 263,
    "y": 280
  }
};

  function buildLivePreview(container, rec, draft) {
    var ns = 'http://www.w3.org/2000/svg';
    var data = rec.variant.preview || {};
    var settings = data.settings || {};
    var position = monogramPositions[String(rec.variant.id)];
    var sourceKey = String(data.image || '').split('/').pop().replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    if (position && position.source !== sourceKey) position = null;
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 516 600');
    svg.setAttribute('class', 'bys-mono__canvas');
    svg.setAttribute('role', 'img');
    var photo = document.createElementNS(ns, 'image');
    photo.setAttribute('href', (position && position.image) || data.image || upscale(rec.variant.image || '', GRID_IMAGE_WIDTH));
    photo.setAttribute('width', '516'); photo.setAttribute('height', '600');
    photo.setAttribute('preserveAspectRatio', 'xMidYMid slice');
    svg.appendChild(photo);
    var lettering = document.createElementNS(ns, 'g');
    lettering.setAttribute('class', 'bys-mono__initials');
    svg.appendChild(lettering); container.appendChild(svg);
    var version = 0;
    function update() {
      var current = ++version;
      lettering.replaceChildren();
      var label = rec.product.title + ' - ' + rec.variant.title;
      svg.setAttribute('aria-label', label);
      var x = Number(settings.horizontal_letter_position);
      var y = Number(settings.vertical_letter_position);
      var w = Number(settings.width_container_desktop);
      var h = Number(settings.height_container_desktop);
      if (!draft.letters || !draft.foil || !cfg.monogram.glyphSample ||
          !Number.isFinite(x) || !Number.isFinite(y) || !(w > 0) || !(h > 0)) return;
      var scale = Number(settings.letter_scale) / 100 || 1;
      var height = 26 * scale;
      var centreX = position ? position.x : (x + w / 2) * 5.16;
      // PDP margin-top percentages resolve against the image width.
      var centreY = position ? position.y : y * 5.16 + h * 3 - 2.5 * scale;
      var base = cfg.monogram.glyphSample.split('/').slice(0, -1).join('/') + '/';
      var prefix = fontName() + '_' + sizeName() + '_' + foilValue(draft.foil) + '_';
      var chars = draft.letters.split('');
      svg.setAttribute('aria-label', label + ', monogram ' + draft.letters + ' in ' + foilLabel(draft.foil) + ' foil');
      var loaded = 0, glyphs = [];
      chars.forEach(function (letter, index) {
        var asset = new Image();
        asset.onload = function () {
          if (current !== version) return;
          glyphs[index] = { url: asset.src, width: height * asset.naturalWidth / asset.naturalHeight };
          if (++loaded !== chars.length) return;
          var total = glyphs.reduce(function (sum, glyph) { return sum + glyph.width; }, 0);
          var left = centreX - total / 2;
          glyphs.forEach(function (glyph) {
            var image = document.createElementNS(ns, 'image');
            image.setAttribute('href', glyph.url);
            image.setAttribute('x', left); image.setAttribute('y', centreY - height / 2);
            image.setAttribute('width', glyph.width); image.setAttribute('height', height);
            lettering.appendChild(image); left += glyph.width;
          });
        };
        asset.src = base + prefix + letter.toLowerCase() + '.png';
      });
    }
    update();
    return update;
  }


    container.replaceChildren();
    return buildLivePreview(container, rec, draft);
  };
})();
